import React from "react"
import { storyblokEditable } from "@storyblok/react"

import { Slider } from "gatsby-theme-gba"
import { createElement } from "./../utils/create-elements"

const SliderEditable = ({ blok }) => (
  <div {...storyblokEditable(blok)} key={blok._uid}>
    <Slider>{createElement(blok, blok.slides)}</Slider>
  </div>
)

export default SliderEditable
